// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"3b1a28d1","517":"4c1caa78","555":"da7d17d8","942":"ecb4bd62"}[chunkId] + ".chunk.js";
};